import React from 'react';

import styles from './GoBack.module.scss';
import { Link } from 'react-router';

const GoBack:React.FC = () => {

		return (
			<section>
				<div className="container">
					<div className={styles.body}>
						<div className={styles.svg}>
							<svg width="707" height="572" viewBox="0 0 707 572" fill="none">
								<path d="M542.857 554.544C679.291 491.897 708.626 254.93 706.239 144.278C700.431 100.889 697.69 25.4412 625.821 14.1578C553.953 2.87431 332.852 -18.6334 118.571 33.6066C-95.7097 85.8466 37.7467 290.271 92.6385 352.173C147.53 414.076 372.313 632.852 542.857 554.544Z" fill="black"/>
							</svg>
						</div>
						<div className={styles.info}>
								<h1>404</h1>
								<h2>страница не найдена</h2>
								<div className={styles.back}>
										<Link to="/">на главную</Link>
								</div>
						</div>
					</div>
				</div>
			</section>
	)
};

export default GoBack;
